// extracted by mini-css-extract-plugin
export default {"sensorCardContainer":"sensor_sensorCardContainer__-IweV","imageContainer":"sensor_imageContainer__TjnIv","details":"sensor_details__-4h6S"};